export default class CookieSelectionOptions {
  public label = ''
  public tooltipText = ''
  public key = ''
}
